import React, { useContext } from 'react'
import ReactDom from 'react-dom'
import styled from 'styled-components'
import tw from 'twin.macro'
import { CloseIcon } from '@components/Icons'
import SocialMediaTextSetting from './social-media-settings/SocialMediaTextSetting'
import SocialMediaImageSetting from './social-media-settings/SocialMediaImageSetting'
import { PortalContext } from '../PortalContext'
import useBodyScrollLock from '@hooks/useBodyScrollLock'
import PublishTimeSection from './PublishTimeSection'

type PublishSettingContainerProps = {
  onClose: () => void
}

export enum PublishModeType {
  PUBLISH_NOW = 'publishNow',
  SCHEDULE_PUBLISH = 'schedulePublish',
}

export enum ScheduleTimeValidationType {
  VALID = 'valid',
  INVALID = 'inValid',
  PENDING = 'pending',
}

const PublishSettingContainer = ({ onClose }: PublishSettingContainerProps) => {
  useBodyScrollLock()

  const portal = useContext(PortalContext)

  if (!portal) return null

  return ReactDom.createPortal(
    <div
      css={[
        tw`bg-white w-full h-screen`,
        tw`fixed left-0 top-0 z-mask`,
        tw`flex justify-center items-center`,
      ]}
    >
      <ModalContent>
        <StyledCloseIcon onClick={onClose} />
        <div css={[tw`flex-shrink-0`, `width: 484px;`, tw`space-y-6`]} data-column>
          <SocialMediaImageSetting />
          <SocialMediaTextSetting />
        </div>
        <div css={[tw`flex-shrink-0`, `width: 284px;`, tw`space-y-4`]} data-column>
          <PublishTimeSection />
        </div>
      </ModalContent>
    </div>,
    portal,
  )
}

export default PublishSettingContainer

const StyledCloseIcon = styled(CloseIcon)`
  ${tw`absolute cursor-pointer`}
  right: 0;
  top: -60px;

  width: 24px;
  height: 24px;
`

const ModalContent = styled.div`
  ${tw`relative flex`};
  min-height: 500px;
  max-height: max-content;

  > [data-column] + [data-column] {
    margin-left: 116px;
  }
`
